import { RouteRecordRaw } from 'vue-router';
import { GenerateRecordPage } from '@/pages/record-fill';

export const routeName = 'PreencherRegistro';

export const route: RouteRecordRaw = {
  path: 'registros-da-qualidade/:prefix/preencher-registro/:recordId',
  name: routeName,
  component: GenerateRecordPage,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'update', subject: 'Record' }],
  },
};
